import { render, staticRenderFns } from "./test-edit.vue?vue&type=template&id=8f4220a0&scoped=true&"
import script from "./test-edit.vue?vue&type=script&lang=ts&"
export * from "./test-edit.vue?vue&type=script&lang=ts&"
import style0 from "./test-edit.vue?vue&type=style&index=0&id=8f4220a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4220a0",
  null
  
)

export default component.exports